"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _times = require("HubStyleTokens/times");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIMedia = _interopRequireDefault(require("../layout/UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("../layout/UIMediaBody"));

var _UIMediaRight = _interopRequireDefault(require("../layout/UIMediaRight"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _UITableHoverContent = _interopRequireDefault(require("./UITableHoverContent"));

var POPOVER_TRANSITION_DELAY = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);
var StyledMedia = (0, _styledComponents.default)(_UIMedia.default).withConfig({
  displayName: "UITableHoverCell__StyledMedia",
  componentId: "sc-1383qtm-0"
})(["height:100%;"]);

var UITableHoverCell = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UITableHoverCell, _Component);

  function UITableHoverCell(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITableHoverCell);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITableHoverCell).call(this, props));

    _this.handleHoverContentOpenChange = function (evt) {
      var rowIsHovered = evt.target.value;

      if (!rowIsHovered !== _this.state.hoverContentIsClosing) {
        // Remove hover content's left margin while closing (#2412)
        _this.setState({
          hoverContentIsClosing: !rowIsHovered
        });
      }

      _this.setState({
        rowIsHovered: rowIsHovered
      });

      if (rowIsHovered) {
        clearTimeout(_this._hideTimeout);

        _this.setState({
          hoverContentIsClosed: false
        });
      } else {
        _this._hideTimeout = setTimeout(function () {
          _this.setState({
            hoverContentIsClosed: true
          });
        }, POPOVER_TRANSITION_DELAY);
      }
    };

    _this.handleTooltipOpenChange = function (evt) {
      _this.setState({
        tooltipIsOpen: !!evt.target.value
      });
    };

    var hoverContentProps = props.hoverContentProps;

    var _rowIsHovered = hoverContentProps ? !!hoverContentProps.open : false;

    _this.state = {
      rowIsHovered: _rowIsHovered,
      hoverContentIsClosed: !_rowIsHovered,
      hoverContentIsClosing: false,
      tooltipIsOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(UITableHoverCell, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this._hideTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          hoverContent = _this$props.hoverContent,
          hoverContentProps = _this$props.hoverContentProps,
          tooltip = _this$props.tooltip,
          truncateStringProps = _this$props.truncateStringProps,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "hoverContent", "hoverContentProps", "tooltip", "truncateStringProps"]),
          _this$state = this.state,
          hoverContentIsClosed = _this$state.hoverContentIsClosed,
          hoverContentIsClosing = _this$state.hoverContentIsClosing,
          rowIsHovered = _this$state.rowIsHovered,
          tooltipIsOpen = _this$state.tooltipIsOpen;
      var open = hoverContentProps && hoverContentProps.open || rowIsHovered || tooltipIsOpen;
      return _react.default.createElement("td", rest, _react.default.createElement(StyledMedia, {
        align: "center"
      }, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement(_UITruncateString.default, Object.assign({
        open: tooltipIsOpen
      }, truncateStringProps, {
        "data-content-hovered": rowIsHovered,
        tooltip: tooltip,
        onOpenChange: this.handleTooltipOpenChange
      }), children)), hoverContent && _react.default.createElement(_UIMediaRight.default, {
        className: (0, _classnames.default)({
          'm-left-0': hoverContentIsClosing && !open,
          'sr-only': hoverContentIsClosed && !open
        })
      }, _react.default.createElement(_UITableHoverContent.default, Object.assign({
        open: open,
        onOpenChange: this.handleHoverContentOpenChange,
        shrinkOnHide: true
      }, hoverContentProps), hoverContent))));
    }
  }]);
  return UITableHoverCell;
}(_react.Component);

exports.default = UITableHoverCell;
UITableHoverCell.propTypes = {
  children: _propTypes.default.node.isRequired,
  hoverContent: _propTypes.default.node,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node, _propTypes.default.string]).isRequired,
  hoverContentProps: _propTypes.default.object,
  truncateStringProps: _propTypes.default.object
};
UITableHoverCell.defaultProps = {
  tooltip: true
};
UITableHoverCell.displayName = 'UITableHoverCell';
module.exports = exports.default;